import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadReport, selectReportById } from '../../Store/slices/reports.slice';
import { Layout, Spin, Card } from 'antd';
import LeadList from "./ReportLayouts/LeadList";

const LEAD_LIST_NAMES = [
    'Advisors Under 200M Custodied with Fidelity'
];

const ReportContainer = () => {
    const { reportId } = useParams();
    const dispatch = useDispatch();
    const report = useSelector((state) => selectReportById(state, reportId));

    console.log(reportId)

    useEffect(() => {
        if (!report) {
            dispatch(loadReport({ reportId }));
        }
    }, [dispatch, reportId, report]);

    if (!report) {
        return <Spin size="large" tip="Loading report..." />;
    }
    console.log(report);
    // Determine which component to render based on the report name
    const renderReport = () => {
        if (LEAD_LIST_NAMES.includes(report.report_name)) {
            console.log(report.data.list)
            return <LeadList data={report.data.list} />;
        }
        // You can add more conditions for different report types here
        // For unknown report types or when no specific component is needed:
        return <p>No specific view for this report.</p>;
    };

    return (
        <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
            <Card title={report.title}>
                <p>{report.description}</p>
                {/* Dynamically render the appropriate component */}
                {renderReport()}
            </Card>
        </Layout.Content>
    );
};

export default ReportContainer;
